// import { canUseDOM } from 'exenv';

export function personPageLoading(resp = {}, store = {}) {
  return {
    type: 'PERSON_PAGE_LOADING',
    personPage: resp,
    store
  };
}

export function personPageLoaded(resp = {}, store = {}) {
  return {
    type: 'PERSON_PAGE_LOADED',
    personPage: resp,
    store
  };
}

export function personPageLoadError(error, store = {}) {
  return {
    type: 'PERSON_PAGE_ERROR',
    personPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
